import { Grid } from "../Grid";
import { useCallback, useEffect, useRef, useState } from "react";
import { ITextFieldProps } from '@talxis/react-components';
import { IQuickFindProps } from "./QuickFindComponent";
import { QuickFind } from "./QuickFind";

export const useQuickFind = (): [IQuickFindProps, (grid: Grid) => void, () => void] => {
    const [quickFindProps, setQuickFindProps] = useState<IQuickFindProps>(null);
    const quickFindRef = useRef<QuickFind>(null);
    const searchValueRef = useRef<string>(null);
    const gridRef = useRef<Grid>(null);

    useEffect(() => {
        return () => {
            gridRef.current?.removeEventListener('onLoading', refresh);
        };
    }, []);

    useEffect(() => {
        searchValueRef.current = gridRef.current?.getSearchQuery();
    }, [gridRef.current?.getSearchQuery()]);

    const createTextFieldProps = (readOnly?: boolean): ITextFieldProps => {
        return {
            value: searchValueRef.current,
            readOnly: readOnly,
            disabled: !gridRef.current || gridRef.current?.loading,
            placeholder: quickFindRef.current.placeholder,
            deleteButtonProps: {
                key: 'delete',
                iconProps: {
                    styles: {
                        root: {
                            fontSize: 14
                        }
                    },
                    iconName: 'Clear'
                },
                onClick: () => {
                    quickFindRef.current.searchValue = null;
                    searchValueRef.current = null;
                    refresh();
                }
            },
            onKeyPress: (e) => {
                if (e.key === 'Enter') {
                    quickFindRef.current.searchValue = searchValueRef.current;
                }
            },
            onChange: (e, newValue) => {
                searchValueRef.current = newValue;
                refresh();
            },
            suffixItems: [
                {
                    key: 'search',
                    iconProps: {
                        iconName: 'Search'
                    },
                    onClick: () => { quickFindRef.current.searchValue = searchValueRef.current; }
                }
            ]
        } as ITextFieldProps;
    };

    const clear = () => {
        searchValueRef.current = null;
        setQuickFindProps({
            textFieldProps: createTextFieldProps(true)
        });
    };

    const init = (grid: Grid) => {
        gridRef.current = grid;
        quickFindRef.current = grid.quickFind;
        searchValueRef.current = quickFindRef.current.searchValue;
        quickFindRef.current.init(refresh);
        grid.addEventListener('onLoading', refresh);
    };
    const refresh = useCallback(() => {
        if (!quickFindRef.current.isVisible()) {
            setQuickFindProps(null);
            return;
        }
        setQuickFindProps({
            textFieldProps: createTextFieldProps()
        });
    }, []);
    return [quickFindProps, init, clear];
};